import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import industryIntegration from "../../images/v4/TgPages/hr/benifit.png";
import clientbg from "../../images/v4/TgPages/clientBg.png";
import salesReppageHerobg from "../../images/v4/TgPages/hr/heroBg.png";
import salesCrmCarouselbg from "../../images/v4/salesManagers/salesCrmbg.png";
import realWorldbg from "../../images/v4/TgPages/salesDevReps/realworld.png";

import salesImg1 from "../../images/v4/TgPages/hr/adapt/img1.svg";
import salesImg2 from "../../images/v4/TgPages/hr/adapt/img2.svg";
import salesImg3 from "../../images/v4/TgPages/hr/adapt/img3.svg";
import salesImg4 from "../../images/v4/TgPages/hr/adapt/img4.svg";
import salesImg5 from "../../images/v4/TgPages/hr/adapt/img5.svg";
import salesImg6 from "../../images/v4/TgPages/hr/adapt/img6.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import bussinessSuccessbg from "../../images/v4/salesManagers/bussinessSuccess.png";
import salesRepHeroImg from "../../images/v4/TgPages/hr/heroImg.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/workable.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/zohoRec.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/breezy.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/recruitee.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import realWorldImage2 from "../../images/v4/TgPages/hr/realWorld/img1.png";
import realWorldImage3 from "../../images/v4/TgPages/hr/realWorld/img2.png";
import realWorldImage4 from "../../images/v4/TgPages/hr/realWorld/img3.png";
import realWorldImage5 from "../../images/v4/TgPages/hr/realWorld/img4.png";
import realWorldImage6 from "../../images/v4/TgPages/hr/realWorld/img5.png";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";

import experienceImg2 from "../../images/v4/TgPages/hr/expericence/img1.png";
import experienceImg3 from "../../images/v4/TgPages/hr/expericence/img2.png";
import experienceImg4 from "../../images/v4/TgPages/hr/expericence/img3.png";
import experienceImg5 from "../../images/v4/TgPages/hr/expericence/img4.png";
import experienceImg6 from "../../images/v4/TgPages/hr/expericence/img5.png";
import designGradeBg from "../../images/v4/TgPages/salesDevReps/designBg.png";
import salesdevpageHerobg from "../../images/v4/TgPages/salesDevReps/saleslogobg.png";

import gradebg1 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg1.png";
import gradebg2 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg2.png";
import gradebg3 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg3.png";
import gradebg4 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg4.png";
import gradebg5 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg5.png";
import arrowRight from "../../images/v4/salesReps/arrowRightWhite.svg";
import transitions from "@material-ui/core/styles/transitions";
import designbg from "../../images/v4/TgPages/designCrm.png";

const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesReppageHerobg})`,
    padding: "130px 0 0",
    backgroundPosition: "center",
    minHeight: "100vh",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
      padding: "60px 0 0 ",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "120px 0 0",
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px 0 0",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      padding: "0",
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "32px",
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
      "& h1": {
        margin: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 64px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    position: "relative",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
      backgroundPositionX: "center",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    maxWidth: "1200px",
    textAlign: "center",
    marginBottom: "90px",
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: " #fff",
    backgroundSize: "cover",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${salesdevpageHerobg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    marginBottom: "20px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    background: " #F7F1FB",
    "& .header-section": {
      width: "50%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
    },

    "& .crmDevReps": {
      display: "flex",
      alignItems: "center",
      gap: "24px",
      "& .cardBlocksSales": {
        width: "50%",
        display: "flex",
        alignItems: "stretch",
        gap: "24px",
        flexWrap: "wrap",
        "@media(max-width:1024px)": {
          width: "100%",
        },
      },
      "@media(max-width:1024px)": {
        flexDirection: "column",
        "& .header-section": {
          width: "100%",
          "& h2": {
            marginBottom: "16px",
          },
          "& p": {
            marginBottom: "24px",
          },
        },
        "& .cardBlocksSales": {
          width: "100%",
        },
      },
    },
  },
  adaptsBox: {
    width: "30%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    borderRadius: "16px",
    color: "#fff",
    position: "relative",
    backdropFilter: "blur(20px)",
    overflow: "hidden",
    "&.sblueCard": {
      background: "#09939A",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: "-1",
          background: "radial-gradient(circle, #783CA8 80%, #783CA8 100%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard": {
      background: "#028BA6",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #028BA6 30%, #014957 50%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      background: "#41086E",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 30%, #B458FF 50%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard": {
      background: "#009A99",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #009A99 30%, #053333 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      background: "rgb(0, 45, 81)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "@media(max-width:520px)": {
      width: "45%",
    },
    "@media(max-width:350px)": {
      width: "100%",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    "& img": {
      width: "40px",
      height: "40px",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",

    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
    "& .rightContent": {
      padding: "32px",
      gap: "46px",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100%",
      "& p": {
        color: "#fff",
      },
      "& img": {
        width: "100%",
      },
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    display: "none",
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      display: "block",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
        padding: "16px",
        borderRadius: "16px",
        overflow: "hidden",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    position: "relative",
    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      width: "100%",
      flexDirection: "row",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "50%",
      },
      "@media only screen and (max-width: 768px)": {
        flexDirection: "column",
        marginBottom: "0",
        gap: "24px",
        "& h2": {
          width: "100%",
          textAlign: "center",
        },
        "& p": {
          width: "100%",
          textAlign: "center",
        },
      },
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "170px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },

  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
    "& p": {
      marginTop: "16px",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },

  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundImage: `url(${designGradeBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
        fontSize: "20px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "16px 24px",
    background: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    overflow: "hidden",
    width: "100%",
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "100%",
      height: "1px",
      background: "rgb(255, 255, 255)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(90deg,rgba(32, 142, 236, 1) 25%, rgba(158, 90, 213, 1) 54%, rgba(255, 255, 255, 1) 80%)",
      left: "-16px",
      borderRadius: "16px",
      top: "0",
      width: "100%",
      height: "2px",
      transform: "scaleX(0) scaleY(1)",
      transformOrigin: "left",
      zIndex: 1,
    },
    "&.active": {
      background: "linear-gradient(270deg, #F8FCFF 0%, #E0EFFD 100%)",
      "&:before": {
        animation: "growTimerY 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media(max-width:768px)": {
        whiteSpace: "normal",
        overflow: "visible",
        textAlign: "left",
        textOverflow: "unset",
      },
    },
    "@media(max-width:768px)": {
      padding: "16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    "@media(max-width:768px)": {
      "& p": {
        display: "none",
      },
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  smallCardContainer: {
    marginTop: "30px",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& $cardContainer": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      marginTop: "16px",
      gap: "15px",
      "& $cardContainer": {
        height: "400px",
        width: "100%",
        padding: "16px",
      },
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",

    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      "&.bannerCard": {
        width: "46%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    backgroundImage: `url(${clientbg})`,
    backgroundRepeat: "no-repeat",

    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "32px",
    },
    "& .client-logo": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },
}));

const AUTO_PLAY_INTERVAL = 10000;

const experienceList = [
  {
    title: "Manage candidates with ease",
    alt: "Manage leads better",
    lintText: "Manage leads better",
    linkUrl: " ",
    img: experienceImg2,
    bgImg: gradebg1,
    desc: "Scattered CVs and communication slow down hiring. Pepper Cloud—the best CRM for recruiters, centralises all applicant data, interview notes, and email history in one place. Track every candidate journey and ensure no opportunity is missed.",
  },
  {
    title: "Turn hiring data into smarter decisions",
    alt: "HR analytics made easy",
    lintText: "HR analytics made easy",
    linkUrl: " ",
    img: experienceImg3,
    bgImg: gradebg2,
    desc: "With real-time insights into sourcing channels, time-to-hire, and pipeline drop-offs, HR teams can stop guessing and optimise recruitment strategies. Use Pepper Cloud CRM to set hiring KPIs, analyse trends, and build high-performing teams.",
  },
  {
    title: "Automate recruitment workflows with AI",
    alt: "Boost productivity with Assist AI",
    lintText: "Boost productivity with Assist AI",
    bgImg: gradebg3,
    linkUrl: " ",
    img: experienceImg4,
    desc: "Let AI take care of follow-ups, reminders, and task allocation—so recruiters can focus on candidate engagement. Pepper Cloud’s automation engine ensures smooth progression through hiring stages, reducing delays and admin time.",
  },
  {
    title: "Personalised candidate engagement",
    alt: "Explore our integrations",
    lintText: "Explore our integrations",
    linkUrl: " ",
    img: experienceImg5,
    bgImg: gradebg4,
    desc: "Segment candidates by role, experience, or hiring stage to deliver relevant, timely messages. Enhance the candidate experience, boost your employer brand, and convert top applicants into long-term team members.",
  },
  {
    title: "Hire from anywhere",
    alt: "See multichannel tools",
    lintText: "See multichannel tools",
    linkUrl: " ",
    img: experienceImg6,
    bgImg: gradebg5,
    desc: "Manage your full hiring pipeline from your phone, review CVs, get real-time updates, schedule interviews, and collaborate instantly. Pepper Cloud’s mobile-optimised CRM supports fast, flexible, and efficient recruitment, whether remote or on-site.",
  },
];
const tabContentData = [
  {
    tabContent: [
      {
        heading: "Candidate shortlisting automation",
        content:
          "Score and match applicants based on job requirements and experience.",
        alt: "Candidate shortlisting automation",
      },
      {
        heading: "Interview coordination",
        content:
          "Automate scheduling, reminders, and feedback collection across roles.",
        alt: "Interview coordination",
      },
      {
        heading: "Placement tracking",
        content:
          "Monitor hiring outcomes and follow-ups in one shared dashboard.",
        alt: "Placement tracking",
      },
      {
        heading: "Client feedback loop",
        content:
          "Collect structured hiring feedback from clients and update applicant status accordingly.",
        alt: "Client feedback loop",
      },
    ],
    image: realWorldImage2,
    alt: "Staffing agencies",
    subtitle:
      "Recruitment firms can streamline candidate sourcing, automate communication, and monitor hiring progress using CRM software tailored to agency workflows.",
  },
  {
    tabContent: [
      {
        heading: "Hiring pipeline visibility",
        content: "View candidate progress and bottlenecks across departments.",
        alt: "Hiring pipeline visibility",
      },
      {
        heading: "Internal collaboration",
        content: "Assign tasks, share interview notes, and align stakeholders.",
        alt: "Internal collaboration",
      },
      {
        heading: "Offer management",
        content:
          "Automate documentation and track offer acceptance or negotiation stages.",
        alt: "Offer management",
      },
      {
        heading: "Compliance tracking",
        content:
          "Store documents, consents, and audit trails in line with hiring regulations and GDPR.",
        alt: "Compliance tracking",
      },
    ],
    image: realWorldImage3,
    alt: "In-house HR teams",
    subtitle:
      "HR departments in SMEs and large enterprises can manage job roles, applicants, and interviews in a central system for better control and collaboration.",
  },
  {
    tabContent: [
      {
        heading: "Client-specific workflows",
        content: "Create tailored pipelines for each client and job role.",
        alt: "Client-specific workflows",
      },
      {
        heading: "Centralised communication",
        content: "Manage client and candidate touchpoints from one platform.",
        alt: "Centralised communication",
      },
      {
        heading: "Talent pool management",
        content:
          "Build and maintain segmented talent databases for future roles.",
        alt: "Talent pool management",
      },
      {
        heading: "Performance reporting",
        content: "Deliver hiring metrics and dashboards to showcase outcomes.",
        alt: "Performance reporting",
      },
    ],
    image: realWorldImage4,
    alt: "Recruitment process outsourcing (RPO) providers",
    subtitle:
      "RPO firms managing recruitment for multiple clients can use CRM to maintain organised records, client preferences, and candidate pools.",
  },
  {
    tabContent: [
      {
        heading: "Application intake automation",
        content: "Collect and filter applicant data via web forms.",
        alt: "Application intake automation",
      },
      {
        heading: "Role-specific workflows",
        content:
          "Use custom hiring stages for academic, administrative, or temporary roles.",
        alt: "Role-specific workflows",
      },
      {
        heading: "Candidate engagement",
        content:
          "Send updates, interview invites, and feedback notifications on time.",
        alt: "Candidate engagement",
      },
      {
        heading: "Panel coordination",
        content:
          "Schedule interviews, manage panel availability, and collect post-interview scores.",
        alt: "Panel coordination",
      },
    ],
    image: realWorldImage6,
    alt: "Educational institutions",
    subtitle:
      "Universities and colleges use CRM to manage faculty hiring, admissions staff recruitment, and contract-based roles more efficiently.",
  },
  {
    tabContent: [
      {
        heading: "Multichannel sourcing",
        content: "Collect applications from job boards, emails, and referrals.",
        alt: "Multichannel sourcing",
      },
      {
        heading: "Time-saving automation",
        content:
          "Reduce manual tasks like email replies and follow-up coordination.",
        alt: "Time-saving automation",
      },
      {
        heading: "Collaborative hiring",
        content:
          "Involve founders or managers in shortlisting and interview decisions with shared dashboards.",
        alt: "Collaborative hiring",
      },
      {
        heading: "Scalable setup",
        content:
          "Adjust pipelines and workflows as your team grows and hiring needs expand.",
        alt: "Scalable setup",
      },
    ],
    image: realWorldImage5,
    alt: "Tech startups and SMEs",
    subtitle:
      "Small businesses can use the best recruitment CRM for small business operations to attract the right talent without complex hiring processes.",
  },
];
const SalesDevReps = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();
  const [activeAccordian, setActiveAccordian] = useState(0);
  const sectionRef = useRef(null);
  const timeoutRef = useRef(null);
  const isInViewRef = useRef(false); // track if section is visible

  // Clear timeout
  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Schedule next change
  const scheduleNext = () => {
    clearTimer();
    if (!isInViewRef.current) return; // only autoplay if section is visible

    timeoutRef.current = setTimeout(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  // Start/pause autoplay based on scroll visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          isInViewRef.current = true;
          scheduleNext(); // resume autoplay
        } else {
          isInViewRef.current = false;
          clearTimer(); // pause autoplay
        }
      },
      { threshold: 0.3 } // section is considered "in view" when 30% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      clearTimer();
    };
  }, [experienceList.length]);

  // Reschedule on activeAccordian change
  useEffect(() => {
    scheduleNext();
    return () => clearTimer();
  }, [activeAccordian, experienceList.length]);

  // Handle user click
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    // scheduleNext will run via useEffect so this stays open full interval
  };

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const benifitList = [
    {
      img: industryIntegration,
      title: "Why do HR teams need CRM software?",
      desc: "Recruitment teams handle hundreds of applications, interviews, and candidate touchpoints daily. Without the right tools, top candidates fall through the cracks. CRM software for recruiters brings structure, efficiency, and consistency to the hiring process. It tracks interactions, automates admin tasks, and offers visibility into every recruitment stage. That’s why the best CRM for HR simplifies workflows, improves candidate experience, and helps teams hire faster.",
    },
  ];
  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.adaptsBox}:first-child`),
      document.querySelector(`.${classes.adaptsBox}.blueCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.regularCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.purpleCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.greenCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.sblueCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const faqs = [
    {
      question: "What makes Pepper Cloud the best CRM for HR and recruitment?",
      answer: (
        <>
          Pepper Cloud offers custom hiring pipelines, automation, and team
          collaboration—all in one easy-to-use platform designed for recruitment
          success.
        </>
      ),
    },
    {
      question: "Can I use Pepper Cloud on my phone?",
      answer: (
        <>
          Yes! Our CRM software for recruiters is available on Android and iOS,
          so you can hire on the move.
        </>
      ),
    },
    {
      question: "Does it support collaborative hiring?",
      answer: (
        <>
          Absolutely. Pepper Cloud lets teams share feedback, track updates, and
          work together on hiring decisions.
        </>
      ),
    },
    {
      question: "Can I automate follow-ups and interview scheduling?",
      answer: (
        <>
          Yes, you can. Use built-in automation to reduce manual tasks and keep
          candidates engaged throughout the hiring journey.
        </>
      ),
    },
    {
      question: "How easy is it to switch from another tool?",
      answer: (
        <>
          Very easy. Our onboarding experts ensure a smooth migration from your
          current system, with zero downtime.
        </>
      ),
    },
    {
      question: "What tools does Pepper Cloud integrate with?",
      answer: (
        <>
          It integrates with Gmail, Outlook, WhatsApp, Google Calendar, and
          more, so your hiring stays connected.
        </>
      ),
    },
  ];
  const adaptList = [
    {
      pointer: "Quick onboarding",
      desc: "Set up quickly, add roles, candidates, and customise your recruitment pipeline effortlessly.",
      img: salesImg1,
      alt: "Clear visibility into the sales pipeline",
      className: "purpleCard",
    },
    {
      pointer: "Automation built-in",
      desc: "Automate interviews, status updates, and follow-ups to focus on top candidates.",
      img: salesImg2,
      alt: "Create whatsapp broadcast message​",
      className: "regularCard",
    },
    {
      pointer: "Visual hiring pipelines",
      desc: "View all roles and candidates clearly with pipelines that simplify hiring decisions.",
      img: salesImg3,
      alt: "Create whatsapp broadcast message​",
      className: "purpleCard",
    },
    {
      pointer: "Mobile access",
      desc: "Hire from anywhere and manage candidate updates with our mobile-optimised CRM.",
      img: salesImg4,
      alt: "CRM for Whatsapp broadcast",
      className: "greenCard",
    },
    {
      pointer: "Tailored for small businesses",
      desc: "The best recruitment CRM for small businesses, simple, scalable, and cost-effective.",
      img: salesImg5,
      alt: "CRM for Whatsapp broadcast",
      className: "sblueCard",
    },
    {
      pointer: "Reliable support",
      desc: "Get 24/7 expert support via phone, chat, or email, never hire alone again.",
      img: salesImg6,
      alt: "CRM for Whatsapp broadcast",
      className: "blueCard",
    },
  ];

  const clientList = [
    {
      img: adaptImg1,
      alt: "Vootours",
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
      alt: "Koss",
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
      alt: "Deluze Printing",
    },
    {
      img: adaptImg6,
      alt: "Caffeine Solutions",
    },
    {
      img: adaptImg7,
      alt: "Travelworkz",
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "Easy-to-use interface with centralised candidate management",
    "Automated follow-ups and reminders for timely hiring",
    "360° candidate view with full communication history",
    "Visual recruitment pipeline to track applicant status",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Workable CRM",
    "Zoho Recruit",
    "Breezy HR",
    "Recruitee",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is the best CRM for HR and small business recruitment teams. From job posting to onboarding, it covers the entire candidate lifecycle in a single platform.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Multichannel communication",
          desc: "Engage candidates via email, WhatsApp, and SMS.",
        },
        {
          title: "Smart workflows",
          desc: "Automate interview scheduling and status updates.",
        },
        {
          title: "Real-time analytics",
          desc: "Monitor hiring progress and team performance.",
        },
        {
          title: "Mobile recruiting",
          desc: "Manage applications and tasks on the go.",
        },
        {
          title: "Custom pipelines",
          desc: "Tailor workflows to match your unique hiring process.",
        },
      ],
    },
    {
      title: "Workable CRM",
      desc: "Workable streamlines candidate sourcing, screening, and collaboration.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "AI-powered sourcing suggestions",
          desc: "Discover top talent faster with smart AI recommendations.",
        },
        {
          title: "Integrated video interviews",
          desc: "Interview candidates remotely without third-party tools.",
        },
        {
          title: "Job board distribution",
          desc: "Publish openings across multiple job boards instantly.",
        },
      ],
    },
    {
      title: "Zoho Recruit",
      desc: "A scalable CRM software for recruiters offering end-to-end talent management.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Resume parsing and keyword search",
          desc: "Quickly filter candidates using advanced search tools.",
        },
        {
          title: "Custom hiring workflows",
          desc: "Design recruitment stages that fit your process.",
        },
        {
          title: "Automated offer letters",
          desc: "Send customised offers in just a few clicks.",
        },
      ],
    },
    {
      title: "Breezy HR",
      desc: "Breezy HR helps teams attract, interview, and hire with minimal effort.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Visual drag-and-drop pipeline",
          desc: "Move candidates through stages effortlessly.",
        },
        {
          title: "Team collaboration tools",
          desc: "Work together seamlessly with shared notes and ratings.",
        },
        {
          title: "Reporting and analytics",
          desc: "Track hiring metrics to optimise processes.",
        },
      ],
    },
    {
      title: "Recruitee",
      desc: "Recruitee is an intuitive platform to manage hiring across teams and departments.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Role-based access controls",
          desc: "Securely manage who can view and edit data.",
        },
        {
          title: "Calendar sync and scheduling",
          desc: "Book interviews and sync with existing calendars.",
        },
        {
          title: "Career page builder",
          desc: "Create branded career pages with ease.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
    {
      pointer: "CRM for IT and tech teams",
      card: {
        pointer: [
          "Streamline service delivery, automate workflows, and manage client support with ease.",
        ],
        img: broadcastImg1,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: " #0A2F4F",
        backgroundImage: " linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Explore the best CRM for HR teams to streamline recruitment, manage candidate pipelines, and hire faster. Pepper Cloud is the best recruitment CRM for small businesses."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="crm for hr,best recruitment crm for small business, best crm for hr, best crm for recruiters, crm software for recruiters"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"CRM for HR and recruitment teams | Simplify hiring"}
      />

      <section className={classes.SalesRepSection}>
        <div className="container">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                CRM for HR and recruitment teams
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Pepper Cloud is the best CRM for HR professionals and recruiters
                who want to simplify hiring, stay organised, and attract top
                talent effortlessly.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage
                alt={"WhatsApp CRM"}
                source={salesRepHeroImg}
                width={"100%"}
              />
            </motion.div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                slidesPerView: 2,
                freeMode: true,
                // grabCursor: false,
                spaceBetween: 40,
                slidesPerGroup: 1,
                // autoplay: false,
                // modules: [],
              },
              // For larger screens (desktop)
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
            }}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            modules={[Autoplay]}
            speed={2500}
            slidesPerView={"auto"}
            // centeredSlides={true}
            spaceBetween={30}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    alt={point.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationRight}>
                <img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  src={benifit.img}
                />
              </div>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1 mt20"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="crmDevReps">
            <div className="header-section">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true, amount: 0.2 }}
              >
                What do recruiters expect from their CRM?
              </motion.h2>
              <motion.p
                className="font-wix-regular font-18 color-black2"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true, amount: 0.2 }}
              >
                Pepper Cloud CRM helps you simplify recruitment pipelines,
                monitor candidate progress in real time, and deliver a smoother,
                more efficient hiring experience across your organisation.
              </motion.p>
            </div>
            <div className="cardBlocksSales">
              {adaptList.map((point, index) => (
                <motion.div
                  className={`${classes.adaptsBox} ${point.className}`}
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true, amount: 0.2 }}
                >
                  <div className={classes.adaptBoxHeader}>
                    <img
                      className={classes.adaptBoxImg}
                      src={point.img}
                      alt=""
                    />
                    <p className="font-18 font-wix-semibold lineHeight-1">
                      {point.pointer}
                    </p>
                  </div>
                  <div className={classes.adaptDescription}>
                    <p className="font-wix-regular font-14">{point.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={classes.accordianTabs}>
        <div className="container">
          <div className="headercenterContainer">
            <motion.h2
              className="font-wix-semibold font-56 text-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              How Pepper Cloud is the best CRM for HR and recruiters
            </motion.h2>
            <p className="font-18 font-wix-regular text-black2">
              Built specifically for recruitment workflows, Pepper Cloud helps
              HR teams eliminate hiring bottlenecks. Automate tasks, manage
              applicants, and collaborate better—so you hire smarter and faster.
            </p>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerLeft} ref={sectionRef}>
              {experienceList.map((faq, index) => (
                <motion.div
                  className={clsx(
                    classes.faqBoxAccordian,
                    index === activeAccordian && "active",
                    "text-color2"
                  )}
                  key={`faq-${index}`}
                  onClick={() => handleAccordionClick(index)}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                >
                  <div className={classes.experienceHeader}>
                    <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                  </div>

                  <Collapse
                    className={classes.collapseBody}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                    <motion.img
                      alt={faq.alt}
                      initial={{ opacity: 1, y: 20 }}
                      src={faq.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      style={{
                        backgroundImage: `url(${faq.bgImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <div
                      className="rightContent"
                      style={{
                        backgroundImage: `url(${experience.bgImg})`, // pass your image URL in experience.bgImage
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <motion.img
                        src={experience.img}
                        initial={{ opacity: 0, x: 50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      />
                      <motion.p
                        className="font-18 font-wix-regular"
                        initial={{ opacity: 0, x: -50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      >
                        {experience.desc}
                      </motion.p>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div className="logos-row" data-direction="left" data-speed="0.8">
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>

      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Application and use cases of CRM for HR and recruitment teams
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Educational
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                In-house HR teams
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Recruitment process
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Staffing agencies
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Tech startups
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 recruitment CRM software for small businesses in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Best CRM for HR - Frequently Asked Questions"}
        />
      </div>
      <DesignCrmCarousel backgroundImage={`url(${designbg})`} bgColor={""} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              CRM for HR and recruitment teams | Streamline hiring with Pepper
              Cloud
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SalesDevReps;
